export enum PlanningEntitySide {
  Left = 'left',
  Right = 'right'
}

export interface PlanningEntity {
  importName: string;
  name: string;
  descriptor: string;
  kind: string;
  side?: PlanningEntitySide;
}
